import type { TeamV2 } from '../../types';

export const isTeamV2 = (entity: any): entity is TeamV2 => entity.__typename === 'TeamV2';

export const getTeamV2Link = (team: TeamV2): string | null => team.profileUrl ?? null;
